import { useAppSelector } from '@app/core/hooks/redux-hooks';
import { getOpmInputsFromPwerm } from '@app/core/inputs/getOpmInputsFromPwerm';

export const useOpmInputsFromPwerm = () => {
  const project = useAppSelector((state) => state.project.projectDraft);
  const calculationResults = useAppSelector((state) => state.pwerm2Calculation.calculatedResults);
  const inputCalculationResults = useAppSelector(
    (state) => state.pwerm2Calculation.calculatedInputs
  );
  return getOpmInputsFromPwerm(project, calculationResults, inputCalculationResults);
};
